import { FC, useState } from 'react';
import EAvatar from '@/components/everridge/EAvatar';
import AddIcon from '@/components/icons/AddIcon';
import ComposeIcon from '@/components/icons/ComposeIcon';
import AccountElement from '@/features/account/components/AccountElement';
import User_02_IconSolid from '@/components/icons/User_02_IconSolid';
import Call_02_IconSolid from '@/components/icons/Call_02_IconSolid copy';
import LegalDocument_01_IconSolid from '@/components/icons/LegalDocument_01_IconSolid';
import IdentityCardIconSolid from '@/components/icons/IdentityCardIconSolid';
import Location_01_IconSolid from '@/components/icons/Location_01_IconSolid';
import { useTranslation } from 'react-i18next';
import EChangeProfilePictureModal from '@/components/everridge/EChangeProfilePictureModal';
import { ProfileDto } from '@/features/account/types/account-dto.ts';
import { cn } from '@/lib/utils';
import { ApiConfig } from '@/config/api.config';

type Props = {
	profile?: ProfileDto;
	isMobile?: boolean;
};

const AccountGeneral: FC<Props> = ({ profile, isMobile }) => {
	const [showChangeProfilePictureModal, setShowChangeProfilePictureModal] =
		useState(false);
	const { t } = useTranslation();

	return (
		<div className='p-6 flex flex-col gap-4 border border-popover-100 rounded-2.5xl bg-popover-10 select-none truncate'>
			<h3 className={cn(isMobile && 'text-base')}>
				{t('main.account.general.title')}
			</h3>
			<div className='flex flex-col gap-4'>
				<div className={'relative size-16'}>
					<EAvatar
						className='h-full w-full'
						url={
							profile?.avatarUrl
								? `${ApiConfig.currentUrls.api.slice(0, -1)}${
										profile?.avatarUrl
								  }`
								: undefined
						}
					/>
					<div
						className={
							'absolute -bottom-1 -right-1 size-8 flex items-center justify-center rounded-full border border-popover-100 bg-popover-10 cursor-pointer'
						}
						onClick={() => setShowChangeProfilePictureModal(true)}>
						{profile?.avatarUrl ? <ComposeIcon /> : <AddIcon />}
					</div>
				</div>
				<AccountElement
					label={t('main.account.general.elements.fullName')}
					value={profile?.fullName || '-'}
					icon={User_02_IconSolid}
				/>
				<AccountElement
					label={t('main.account.general.elements.phoneNumber')}
					value={profile?.phoneNumber || '-'}
					icon={Call_02_IconSolid}
				/>
				<AccountElement
					label={t('main.account.general.elements.tin')}
					value={profile?.tin || '-'}
					icon={LegalDocument_01_IconSolid}
				/>
				<AccountElement
					label={t('main.account.general.elements.id')}
					value={profile?.personalId || '-'}
					icon={IdentityCardIconSolid}
				/>
				<AccountElement
					label={t('main.account.general.elements.address')}
					value={profile?.address || '-'}
					icon={Location_01_IconSolid}
				/>
			</div>
			{showChangeProfilePictureModal && (
				<EChangeProfilePictureModal
					pictureUrl={profile?.avatarUrl}
					onClose={() => setShowChangeProfilePictureModal(false)}
					isMobile={isMobile}
				/>
			)}
		</div>
	);
};

export default AccountGeneral;
